import React from 'react';
import { FlatList } from 'react-native';
import { sectionListStyles } from 'LocalGluons';
import ChannelFavoriteListItem from '../ChannelFavoriteListItem';

interface ChannelFavoriteListProps {
    data: [];
    onItemPress: (item: { name: string; channelId: number }) => void;
}

interface renderItemsProps {
    item: {
        name: string;
        channelId: number;
    };
    index: number;
}

const ChannelFavoriteList = ({
    data,
    onItemPress
}: ChannelFavoriteListProps): React.ReactElement => {
    data.sort((a: { name: string }, b: { name: string }): number => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });

    return (
        <FlatList
            style={[sectionListStyles.container, { paddingTop: 6 }]}
            data={data}
            renderItem={({ item, index }: renderItemsProps) => (
                <ChannelFavoriteListItem
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...item}
                    testID={`package_${index}`}
                    onPress={() => onItemPress(item)}
                />
            )}
            keyExtractor={(item) => `${item.name}-${item.channelId}`}
        />
    );
};

export default ChannelFavoriteList;
